import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import {
  ChangePayScheduleEditScreenContainer,
  DateOfPaymentContainer,
  PaymentDateHeader,
  PayPlanButtonContainer,
  PayScheduleEditHeader,
  RequiredField,
  SelectPayMethodHeader,
  SelectPayPlanHeader,
  StyledPayDateInput,
} from './styles';

import PayScheduleTable from './payScheduleTable';
import FundingInstruments from './fundingInstruments';
import { setDateToPay, setNewPlanSchedule } from './payPlanReducer';
import { setPaymentInstrument } from '../make-payment/step-two-amount/makePaymentStepTwoReducer';
import { handlePayDateChange } from './utils';
import Loader from '../../common/loader';

export const EditPaySchedule = (props) => {
  const { account, dispatch, isLoading, newPlan, payPlanDateToPay, payPlanOptions, i18n } = props;
  let payPlanOptionsMapped = payPlanOptions.map((plan) => {
    return { ...plan, label: plan.name, value: plan.payPlanCd };
  });
  const handlePlanScheduleChange = (plan) => {
    if (plan.payPlanCd === 'Direct Pay In Full-NB') {
      dispatch(setPaymentInstrument(null));
      dispatch(setDateToPay(''));
      //if they previously had set their payment we want to null that out.
    }
    dispatch(setNewPlanSchedule(plan));
  };

  return (
    <ChangePayScheduleEditScreenContainer>
      <PayScheduleEditHeader>Payment Schedule</PayScheduleEditHeader>
      <SelectPayPlanHeader>
        Select your new payment schedule
        {isLoading && <Loader loaderwidth="20px" loaderheight="20px" />}
      </SelectPayPlanHeader>
      <PayPlanButtonContainer>
        <Select
          id="payPlanSelector"
          options={payPlanOptionsMapped}
          value={newPlan}
          isDisabled={isLoading}
          defaultValue={{ label: '-- Select a Plan --', value: 'default' }}
          onChange={handlePlanScheduleChange}
        />
      </PayPlanButtonContainer>
      {newPlan ? (
        <div>
          <h1>Your New Payment Schedule</h1>
          {newPlan?.payPlan?.schedule && <PayScheduleTable schedule={newPlan.payPlan.schedule} />}
        </div>
      ) : null}
      <DateOfPaymentContainer>
        {newPlan &&
        newPlan.payPlanCd !== 'Direct Pay In Full-NB' &&
        newPlan.payPlan.dayOfMonthInd !== 'No' ? (
          <>
            <PaymentDateHeader>
              What day of the month do you want to pay?
              {newPlan.payPlan.dayOfMonthInd === 'Required' && <RequiredField> *</RequiredField>}
            </PaymentDateHeader>
            <StyledPayDateInput
              id="payDateSelect"
              max="31"
              min="1"
              value={payPlanDateToPay}
              onChange={(e) => handlePayDateChange(e.target.value, dispatch)}
            />
          </>
        ) : null}
      </DateOfPaymentContainer>

      {newPlan && !newPlan?.payPlan?.payPlanTypeCd?.includes('None') ? (
        <>
          <SelectPayMethodHeader>Select your payment method.</SelectPayMethodHeader>
          <FundingInstruments payScheduleAccount={account} />
        </>
      ) : null}
    </ChangePayScheduleEditScreenContainer>
  );
};
EditPaySchedule.propTypes = {
  account: PropTypes.object,
  dispatch: PropTypes.func,
  i18n: PropTypes.object,
  isLoading: PropTypes.bool,
  payPlanDateToPay: PropTypes.string,
  payPlanOptions: PropTypes.array,
  newPlan: PropTypes.object,
};
export const mapStateToProps = (state) => ({
  state,
  billingAccounts: state.billingSlice.billingAccounts,
  payPlanDateToPay: state.payPlanSlice.payPlanDateToPay,
  payPlanOptions: state.payPlanSlice.payPlanOptions,
  isLoading: state.payPlanSlice.isLoading,
  newPlan: state.payPlanSlice.newPlan,
});

export default connect(mapStateToProps)(EditPaySchedule);
